var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"hidden items-center space-x-1 text-sm sm:flex"},[_vm._t("default",function(){return [_c('z-icon',{attrs:{"icon":_vm.icon,"size":"x-small","color":_vm.color}}),_vm._v(" "),_c('span',{staticClass:"text-sm",class:[`text-${_vm.color}`]},[_vm._v(_vm._s(_vm.title))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }